export const formatSystemAge = (age?: number | string | null) => {
  if (age === undefined || age === null || age === "") return ""

  const numericAge = Number(age)

  if (Number.isNaN(numericAge)) return ""
  if (numericAge < 3) return "Less than 3 years"
  if (numericAge >= 20) return "More than 20 years"
  if (numericAge >= 15) return "More than 15 & Less than 20 years"
  if (numericAge >= 10) return "More than 10 & Less than 15 years"
  if (numericAge >= 8) return "More than 8 & Less than 10 years"
  if (numericAge >= 5) return "More than 5 years"
  return "More than 3 years"
}
